/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useEffect } from 'react';
import { load } from 'recaptcha-v3';
import { coreBaseURL, post } from '../util/http';

type Props = {
  onResolved: (value: boolean) => void;
};

export function RecaptchaAuthComponent({ onResolved }: Props) {
  const url = window.location.host;

  const verifyCaptcha = async (token) => {
    try {
      const res = await post(`${coreBaseURL}/verify-captcha`, {
        token: token,
        url,
      });
      if (res.ok) {
        const data = await res.json();
        onResolved(data);
      }
    } catch (e) {
      //
    }
  };

  useEffect(() => {
    asyncFunction(process.env.NX_CAPTCHA_SITE_KEY);
  }, []);
  async function asyncFunction(key = '') {
    const recaptcha = await load(key);
    const token = await recaptcha.execute();
    await verifyCaptcha(token);
  }
  return <div></div>;
}
